// Maps internal certificate slug -> public URL slug per language.
// SV slugs match the old intygslakaren.se URLs exactly so old links keep working.
export const certificatePathSlugs: Record<string, { sv: string; en: string }> = {
  "hogre-behorighet": { sv: "hogre-behorighet", en: "higher-driving-license" },
  "c-ce": { sv: "c-ce", en: "truck-c-ce" },
  "d-de": { sv: "d-de", en: "bus-d-de" },
  "buss-lastbil": { sv: "buss-lastbil", en: "bus-and-truck" },
  "taxi": { sv: "taxi", en: "taxi-driver-licence" },
  "alkolas": { sv: "lakarintyg-alkolas", en: "alcohol-interlock-certificate" },
  "droger-alkohol": { sv: "lakarintyg-droger-och-alkohol", en: "drug-and-alcohol-certificate" },
  "salivtest": { sv: "salivtest", en: "saliva" },
  "urinprov": { sv: "urinprov", en: "urine" },
  "korkort-adhd": { sv: "lakarintyg-korkort-adhd-add-autism", en: "driving-license-adhd-add-autism" },
  "korkort-diabetes": { sv: "lakarintyg-korkort-diabetes", en: "driving-license-diabetes" },
  "korkort-hjarta": { sv: "lakarintyg-korkort-hjart--och-karlhalsan", en: "driving-license-cardiovascular" },
  "offshore": { sv: "offshore", en: "offshore" },
  "oguk": { sv: "oguk-ouek", en: "oguk-ouek" },
  "sjofolksintyg": { sv: "sjofolksintyg", en: "seafarers-certificate" },
  "au-pair": { sv: "au-pair-intyg", en: "au-pair-certificate" },
  "forstadagsintyg": { sv: "forstadagsintyg", en: "first-day-sickness-certificate" },
  "utlandsstudier": { sv: "lkarintyg-utlandsstudierarbete", en: "studies-or-work-abroad" },
  "nattarbete": { sv: "afs-nattarbete", en: "night-work" },
  "fit-for-fly": { sv: "fit-for-fly-friskintyg", en: "fit-to-fly-certificate" },
  "installd-resa": { sv: "installd-resa", en: "cancelled-trip-certificate" },
  "reseintyg-gravid": { sv: "reseintyg-gravid", en: "pregnancy-travel-certificate" },
  "intyg-forsakring": { sv: "intyg-for-forskring", en: "insurance-certificate" },
  "invaliditetsintyg": { sv: "invaliditetsintyg", en: "disability-certificate" },
  "fallskarmsintyg": { sv: "fallskarmsintyg", en: "skydiving-certificate" },
  "tavlingsintyg": { sv: "tavlingsintyg", en: "competition-certificate" },
  "adoptionsintyg": { sv: "adoptionsintyg", en: "adoption-certificate" },
  "afs-allergi-kemiska": { sv: "afs-allergiframkallande-kemiska-arbeten", en: "afs-allergenic-chemical-work" },
  "afs-asbest": { sv: "afs-asbest-kvarts-och-syntetiska-oorganiska-fibrer", en: "afs-asbestos-quartz-synthetic-fibres" },
  "afs-bly": { sv: "afs-bly", en: "afs-lead" },
  "afs-handintensivt": { sv: "afs-handintensivtarbete", en: "afs-hand-intensive-work" },
  "afs-klattring": { sv: "afs-klattring-med-stor-nivskillnad", en: "afs-climbing-at-great-heights" },
  "afs-mast-stolpe": { sv: "afs-mast-och-stolparbete", en: "afs-mast-and-pole-work" },
  "afs-vibrationer": { sv: "afs-vibrationer", en: "afs-vibrations" },
  "afs-allergi-produkter": { sv: "afs-allergiframkallanes-kemiska-produkter", en: "afs-allergenic-chemical-products" },
  "ovriga": { sv: "ovriga-intyg", en: "other-certificates" },
};

export const certificatePathFor = (internalSlug: string, lang: "sv" | "en"): string => {
  const entry = certificatePathSlugs[internalSlug];
  const slug = entry ? entry[lang] : internalSlug;
  return lang === "sv" ? `/lakarintyg/${slug}` : `/en/medical-certificates/${slug}`;
};

export const findCertificateBySlug = (slug: string, lang: "sv" | "en"): string | null => {
  for (const [internal, entry] of Object.entries(certificatePathSlugs)) {
    if (entry[lang] === slug) return internal;
  }
  return null;
};

export const otherLangSlug = (internalSlug: string, otherLang: "sv" | "en"): string | undefined => {
  return certificatePathSlugs[internalSlug]?.[otherLang];
};